<template>
  <router-view />
</template>
<script>
import { Device } from "@capacitor/device";
import { App } from "@capacitor/app";

import axios from "@/plugins/axios.js";
import { onMounted, reactive } from "vue";
export default {
  name: "App",
  setup() {
    //provide를 통해 제공하고 inject를 통해 사용
    //provide("axios", _axios);

    const viewport = document.getElementById("viewport");

    if (screen.width < 360) {
      viewport.setAttribute(
        "content",
        "width=360, maximum-scale=1, user-scalable=no"
      );
    }

    window.addEventListener("resize", function () {
      if (screen.width < 360) {
        viewport.setAttribute(
          "content",
          "width=360, maximum-scale=1, user-scalable=no"
        );
      } else {
        viewport.setAttribute(
          "content",
          "width=device-width, initial-scale=1.0, maximum-scale=1, user-scalable=no"
        );
      }
    });
    const versionCheck = reactive({
      checkVersion: (cur, min) => {
        let curList = cur.split(".");
        let minList = min.split(".");
        let verStep = curList.length;
        if (verStep > minList.length) verStep = minList.length;

        let loopCnt = 0;
        let result = false;
        // 현재 버전이 최소버전보다 높다면 false 를 리턴한다.
        // Ture 라면 업데이트를 해야한다.

        curList.forEach((item) => {
          if (loopCnt < verStep) {
            if (Number(item) < Number(minList[loopCnt])) {
              result = true;
            }
          }
          loopCnt++;
        });
        return result;
      },

      startVersionCheck: async () => {
        let res = await axios.get(
          "https://kr.object.ncloudstorage.com/apks/myclass/myClass-appVersion.json?q=" +
            new Date().getTime(),
          {}
        );
        console.log("res", res.data.android);
        console.log("res", res.data.ios);

        const androidStore = "market://details?id=com.carrot.itm_my_class";
        const iosStore = "https://apps.apple.com/us/app/my-class/id6450909895";
        let result = false; // 버전 비교 결과값, true 인 경우 버전을 올려야만 한다.
        let storeURL = ""; // 스토어 주소를 저장하기 위한 값.
        let deviceVersion = ""; //앱 버전정보를 위한 값

        //디바이스 구분 정보를 가져오기 위함.
        let device = await Device.getInfo();
        console.log("device", device);
        //안드로이드나 IOS가 아니라면 이후 프로세스를 진행하지 않는다.
        if (device.platform == "android" || device.platform == "ios") {
          //앱의 버전 정보를 가져오기 위함.
          let app = await App.getInfo();
          console.log("app", app);
          deviceVersion = app.version;

          if (device.platform == "android") {
            //안드로이드 인 경우
            result = versionCheck.checkVersion(deviceVersion, res.data.android);
            storeURL = androidStore;
          } else if (device.platform == "ios") {
            //아이폰인 경우
            result = versionCheck.checkVersion(deviceVersion, res.data.ios);
            storeURL = iosStore;
          }
          if (result) {
            if (
              confirm(`필수 업데이트가 있습니다.
    App 최신 기능 사용을 위해 업데이트를 하시겠습니까?`)
            ) {
              window.open(storeURL);
              //앱을 종료시키는 코드를 넣는다.
              //안드로이드만 동작함.
              App.exitApp();
            } else {
              //앱을 종료시키는 코드를 넣는다.
              //안드로이드만 동작함.
              App.exitApp();
            }
          }
        }
      },
    });
    onMounted(() => {
      versionCheck.startVersionCheck();
    });
    return { versionCheck };
  },
};
</script>
<style lang="scss">
@import "@/assets/styles/reset.scss";
</style>
